// extracted by mini-css-extract-plugin
export var categories = "category-browser-module--categories--lHn22";
export var categoriesHeader = "category-browser-module--categories-header--3dUaS";
export var container = "category-browser-module--container--36-Gv";
export var innerWrapper = "category-browser-module--inner-wrapper--3efg4";
export var outerWrapper = "category-browser-module--outer-wrapper--QTlsJ";
export var placedBottomInnerWrapper = "category-browser-module--placed-bottom-inner-wrapper--2NNmF";
export var placedBottomOuterWrapper = "category-browser-module--placed-bottom-outer-wrapper---W6sW";
export var placedBottomSection = "category-browser-module--placed-bottom-section--RbtmW";